import { gql } from '@apollo/client';

// 엑셀 업로드 뮤테이션
export const UPLOAD_EXCEL_DATA = gql`
  mutation UploadExcelData($request: ExcelUploadRequest!) {
    uploadExcelData(request: $request) {
      success
      uploadId
      totalRows
      successRows
      failRows
      status
      errors {
        rowNum
        columnName
        columnValue
        errorCode
        errorMessage
      }
      message
      processTime
    }
  }
`;

// 엑셀 업로드 이력 조회
export const GET_EXCEL_UPLOAD_HISTORIES = gql`
  query GetExcelUploadHistories($filter: ExcelUploadHistoryFilter) {
    getExcelUploadHistories(filter: $filter) {
      id
      uploadId
      targetTable
      originalFilename
      fileSize
      totalRows
      successRows
      failRows
      status
      uploadDate
      uploadUser
      processTime
      errorMessage
    }
  }
`;

// 특정 업로드의 에러 로그 조회
export const GET_EXCEL_UPLOAD_ERRORS = gql`
  query GetExcelUploadErrors($uploadId: String!) {
    getExcelUploadErrors(uploadId: $uploadId) {
      rowNum
      columnName
      columnValue
      errorCode
      errorMessage
    }
  }
`;

// 엑셀 템플릿 정보 조회
export const GET_EXCEL_TEMPLATE_INFO = gql`
  query GetExcelTemplateInfo($targetTable: String!) {
    getExcelTemplateInfo(targetTable: $targetTable) {
      targetTable
      templateName
      columns {
        field
        headerName
        required
        dataType
        maxLength
        defaultValue
        description
      }
      sampleData
      validationRules
    }
  }
`; 